module.exports = __webpack_public_path__ + "img/bg-sp.169fff74.png";